document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.product_tile_buttons .add_to_cart_button').forEach(function(button) {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            
            const variantId = this.getAttribute('data-cart-add');
            if (!variantId) {
                console.error('No variant ID found');
                return;
            }
            
            // Disable button during request
            this.style.pointerEvents = 'none';
            this.style.opacity = '0.6';
            
            // Get cart drawer element
            const cartDrawer = document.querySelector('cart-drawer');
            
            // Prepare form data
            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', 1);
            
            // Add sections to render if cart drawer exists
            if (cartDrawer) {
                const sections = cartDrawer.getSectionsToRender().map(section => section.section);
                formData.append('sections', sections.join(','));
                formData.append('sections_url', window.location.pathname);
            }
            
            // Fetch config
            const config = {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/javascript'
                },
                body: formData
            };
            
            // Add to cart
            fetch(window.routes.cart_add_url, config)
                .then(response => response.json())
                .then(response => {
                    if (response.status || response.errors) {
                        console.error('Error adding to cart:', response.description || response.errors);
                        alert('Unable to add product to cart. Please try again.');
                        return;
                    }
                    
                    // Render cart drawer contents and open it
                    if (cartDrawer) {
                        cartDrawer.renderContents(response);
                    }
                    
                    // Update cart counters
                    if (typeof updateCartCounters === 'function') {
                        updateCartCounters();
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                    alert('An error occurred. Please try again.');
                })
                .finally(() => {
                    // Re-enable button
                    this.style.pointerEvents = '';
                    this.style.opacity = '';
                });
        });
    });
});